import React, { useState } from "react";
import "@frameworks/web/stylesheets/components/Reports/TAXReports/TaxBudgetDisclaimer.scss";
import { taxBudgetMessage } from "../constant";
import DeviceContext from "@frameworks/web/components/generic/customHooks/indentifyDevice";
import { LoginSource } from "@domains/utils/emtReportCallback";
import { useParams } from "react-router-dom";
import { Modal } from "react-bootstrap";
const TaxBudgetDisclaimer = (props) => {
    const device = DeviceContext();
    const [showBudgerMessage, setShowBudgetPopup] = useState(true);
    const { loginOrigin } = useParams();
    const salesNativeApp = JSON.parse(localStorage.getItem("sales_native_app"));
    if (loginOrigin === LoginSource.SALES || salesNativeApp)
        return (React.createElement("div", { className: "tax-disclaimer-sales" },
            React.createElement(Modal, { show: showBudgerMessage && props.liesInTaxBudgetDateRange, onHide: () => setShowBudgetPopup(false), centered: true },
                React.createElement(Modal.Header, { closeButton: true },
                    React.createElement(Modal.Title, null,
                        React.createElement("div", { className: "txt-blue-shade-20 DMSanN_14_400" }, " Disclaimer"))),
                React.createElement(Modal.Body, { className: "txt-brownish-grey disclaimer-msg DMSanN_14_400" },
                    React.createElement("div", null, taxBudgetMessage)))));
    if (showBudgerMessage && props.liesInTaxBudgetDateRange)
        return (React.createElement("div", { className: "tax-budget-container" },
            React.createElement("div", { className: "tax-budget-disclaimer" },
                React.createElement("div", { className: "edel-icon-attention-icon txt_orange-shade" }),
                React.createElement("div", { className: "d-flex flex-column content" },
                    React.createElement("div", { className: "txt-blue-shade-20 DMSanN_14_400" }, "Disclaimer"),
                    React.createElement("div", { className: `${(device === null || device === void 0 ? void 0 : device.isDesktop) ? "DMSanN_14_400" : "DMSanN_12_400"} txt-brownish-grey disclaimer-msg` }, taxBudgetMessage)),
                React.createElement("div", { className: "edel-icon-close hand_cursor", onClick: () => setShowBudgetPopup(false) }))));
    return React.createElement(React.Fragment, null);
};
export default TaxBudgetDisclaimer;
